<button 
    mat-mini-fab
    class="admin-theme"
    [matMenuTriggerFor]="menu">
    <mat-icon>account_circle</mat-icon>
</button>

<mat-menu #menu="matMenu" class="admin-theme">
    <button mat-menu-item (click)="logout()">Abmelden</button>
</mat-menu>
